import {
  organizationFetchData,
  fetchOrganizationDataById,
  toggleOrganizationForm,
  createOrganization,
  editOrganization,
  organizationArchive,
  updateOrganizationField,
  organizationChurn,
  organizationRestore,
  setMyEntitiesOnly,
  resetOrganizationListData,
  organizationFetchStatbarData,
} from '../../routines';

const initialState = {
  list: [],
  sublists: {}, // experimental @shayne
  listPageData: {},
  statbarData: [],
  statbarDataLoading: false,
  statbarData360: [],
  selectedEntity: null,
  error: null,
  showCreatePanel: false,
  createLoading: false,
  listLoading: false,
  entityLoading: false,
  organizationArchiving: false,
  organizationRestoring: false,
  organizationChurning: false,
  currentPayload: null, // the payload used for the current result set
  myEntitiesOnly: false,
};

const exampleReducer = (state = initialState, action) => {
  switch (action.type) {
    case resetOrganizationListData.TRIGGER:
      return {
        ...initialState,
        listLoading: state.listLoading,
        currentPayload: state.currentPayload,
        selectedEntity: state.selectedEntity,
      };
    case setMyEntitiesOnly.TRIGGER:
      return {
        ...state,
        myEntitiesOnly: action.payload.myEntitiesOnly,
      };
    case editOrganization.TRIGGER: {
      return {
        ...state,
        createLoading: true,
        listLoading: true,
        entityLoading: true,
      };
    }
    case createOrganization.TRIGGER: {
      return {
        ...state,
        createLoading: true,
      };
    }
    case editOrganization.SUCCESS: {
      return {
        ...state,
        showCreatePanel: false,
        createLoading: false,
        listLoading: false,
        entityLoading: false,
      };
    }
    case createOrganization.SUCCESS: {
      return {
        ...state,
        showCreatePanel: false,
        createLoading: false,
      };
    }

    case editOrganization.FAILURE:
    case createOrganization.FAILURE: {
      return {
        ...state,
        createLoading: false,
      };
    }
    case toggleOrganizationForm.TRIGGER: {
      return {
        ...state,
        showCreatePanel: action.payload.showForm,
      };
    }
    case organizationArchive.TRIGGER:
      return {
        ...state,
        organizationArchiving: true,
      };

    case organizationArchive.SUCCESS:
    case organizationArchive.FAILURE:
      return {
        ...state,
        organizationArchiving: false,
      };

    case organizationRestore.TRIGGER:
      return {
        ...state,
        organizationRestoring: true,
      };

    case organizationRestore.SUCCESS:
    case organizationRestore.FAILURE:
      return {
        ...state,
        organizationRestoring: false,
      };

    case organizationChurn.TRIGGER:
      return {
        ...state,
        organizationChurning: true,
      };

    case organizationChurn.SUCCESS:
    case organizationChurn.FAILURE:
      return {
        ...state,
        organizationChurning: false,
      };
    case organizationFetchStatbarData.TRIGGER: {
      return {
        ...state,
        statbarDataLoading: true,
      };
    }
    case organizationFetchStatbarData.FAILURE: {
      return {
        ...state,
        statbarDataLoading: false,
      };
    }
    case organizationFetchStatbarData.SUCCESS: {
      return {
        ...state,
        statbarData: action.payload.statbarData,
        statbarDataLoading: false,
      };
    }
    case organizationFetchData.TRIGGER:
      return {
        ...state,
        listLoading: true,
      };
    case organizationFetchData.SUCCESS: {
      const newState = {
        ...state,
        list: action.payload.preservePreviousList
          ? [...state.list, ...action.payload.data]
          : action.payload.data,
        listPageData: {
          itemCount: action.payload.itemCount,
          page: action.payload.page,
          pageSize: action.payload.pageSize,
          totalItems: action.payload.totalItemCount,
          totalEntities: action.payload.totalEntityCount,
          lifecycleGroupTotalItemCounts: {
            ...state.listPageData.lifecycleGroupTotalItemCounts,
            ...action.payload.lifecycleGroupTotalItemCounts,
          },
        },
        listLoading: false,
        currentPayload: action.payload.currentPayload,
      };
      // newState.sublists = {
      //   ...state.sublists,
      //   [action.payload.page]: action.payload.data,
      // };
      // if (
      //   action.payload.preservePreviousList &&
      //   action.payload.currentPayload.isBoard
      // ) {
      //   newState.sublists = {
      //     ...state.sublists,
      //     [action.payload.page]: action.payload.data,
      //   };
      //   newState.list = Object.values(newState.sublists)
      //     .splice(0, action.payload.page - 1)
      //     .flat();
      // } else {
      //   newState.list = action.payload.data;
      // }
      return newState;
    }
    case organizationFetchData.FAILURE:
      return {
        ...state,
        error: true,
        listLoading: false,
      };
    case fetchOrganizationDataById.TRIGGER:
      return {
        ...state,
        entityLoading: true,
      };
    case fetchOrganizationDataById.SUCCESS:
      return {
        ...state,
        selectedEntity: action.payload.data,
        statbarData360: action.payload.statbarData,
        entityLoading: false,
      };
    case fetchOrganizationDataById.FAILURE:
      return {
        ...state,
        error: true,
        entityLoading: false,
      };
    case updateOrganizationField.SUCCESS: {
      const { organizationId, data } = action.payload;
      const organizationIndex = state.list.findIndex(
        (element) => element.organizationId === organizationId
      );
      return {
        ...state,
        list: [
          ...state.list.slice(0, organizationIndex),
          { ...state.list[organizationIndex], ...data },
          ...state.list.slice(organizationIndex + 1),
        ],
      };
    }
    default:
      return state;
  }
};

export default exampleReducer;
